// extracted by mini-css-extract-plugin
export var hideEditor = "_mw-2";
export var infoIcon = "_mw-3";
export var label = "_mw-1";
export var labelContainer = "_mw-0";
export var readonlyText = "_mw-4";